// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionList_container__2m-6e","title":"SessionList_title__28sPK","content":"SessionList_content__2yiTp"};